/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_Select_FileInputs */

const en_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a file`)
};

const fr_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un fichier`)
};

const de_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Datei aus.`)
};

const it_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file`)
};

const ru_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите файл.`)
};

const es_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione un archivo`)
};

const zh_cn2_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择文件`)
};

const ja_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを選択してください`)
};

const hi_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक फ़ाइल चुनें`)
};

const pt_pt2_please_select_file = /** @type {(inputs: Please_Select_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um arquivo.`)
};

/**
* | output |
* | --- |
* | "Please select a file" |
*
* @param {Please_Select_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const please_select_file = /** @type {((inputs?: Please_Select_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_Select_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_please_select_file(inputs)
	if (locale === "de") return de_please_select_file(inputs)
	if (locale === "it") return it_please_select_file(inputs)
	if (locale === "ru") return ru_please_select_file(inputs)
	if (locale === "es") return es_please_select_file(inputs)
	if (locale === "zh-CN") return zh_cn2_please_select_file(inputs)
	if (locale === "ja") return ja_please_select_file(inputs)
	if (locale === "hi") return hi_please_select_file(inputs)
	if (locale === "pt-PT") return pt_pt2_please_select_file(inputs)
	return en_please_select_file(inputs)
});